// extracted by mini-css-extract-plugin
export var container = "_cu-0";
export var icon = "_cu-1";
export var text = "_cu-2";